import React from 'react';
import { combineClassNames } from '../util/css/classNames.js';
import styles from './Lead.scss';
export const Lead = ({ children, className, style }) => (React.createElement("p", { className: combineClassNames(className, styles.lead), style }, children));
